import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import { TicketWaitlist }   from "Utils/API";



// The initial State
const initialState = {
    loading   : true,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canFilter : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    statuses  : [],
    sort      : {
        orderBy  : "position",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "TICKET_WAITLIST_LOADING" });
    },

    /**
     * Fetches the Ticket Waitlist List
     * @param {Function} dispatch
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, params = {}) {
        const data = await TicketWaitlist.getAll(params);
        data.sort = params;
        dispatch({ type : "TICKET_WAITLIST_LIST", data });
    },

    /**
     * Fetches a single Ticket Waitlist
     * @param {Function} dispatch
     * @param {Number}   ticketWaitlistID
     * @returns {Promise}
     */
    async fetchElem(dispatch, ticketWaitlistID) {
        const data = await TicketWaitlist.getOne({ ticketWaitlistID });
        dispatch({ type : "TICKET_WAITLIST_ELEM", data });
    },

    /**
     * Fetches the Ticket Waitlist Edit data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchEditData(dispatch) {
        const data = await TicketWaitlist.getEditData();
        dispatch({ type : "TICKET_WAITLIST_EDIT", data });
    },

    /**
     * Edits a Ticket Waitlist
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return TicketWaitlist.edit(data);
    },

    /**
     * Deletes a Ticket Waitlist
     * @param {Function} dispatch
     * @param {Number}   ticketWaitlistID
     * @returns {Promise}
     */
    deleteElem(dispatch, ticketWaitlistID) {
        return TicketWaitlist.delete({ ticketWaitlistID });
    },
};



/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "TICKET_WAITLIST_LIST", "TICKET_WAITLIST_ELEM", "TICKET_WAITLIST_EDIT")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "TICKET_WAITLIST_LOADING":
        return {
            ...state,
            loading   : true,
        };

    case "TICKET_WAITLIST_LIST":
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canFilter : action.data.canFilter,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : action.data.list,
            total     : action.data.total,
            sort      : action.data.sort,
        };

    case "TICKET_WAITLIST_ELEM":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            elem      : action.data.elem,
            statuses  : action.data.statuses,
        };

    case "TICKET_WAITLIST_EDIT":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            statuses  : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
